import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';

import { SAVED_FILTERS_QUERY_KEYS } from 'app/modules/filters/queries/keys';
import { Filter, SavedFilter } from 'app/modules/filters/models';
import { put } from 'app/shared/utils/fetchr';
import { sendErrorToast, sendSuccessToast } from 'app/shared/toasts/actions';

interface UpdateSavedFilterPayload {
  title?: string;
  description?: string;
  filters?: Filter[];
  team_ids?: number[];
}

export const useUpdateSavedFilter = () => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      id,
      ...payload
    }: { id: number } & UpdateSavedFilterPayload) =>
      put<SavedFilter>(`/v1/saved-filters/${id}`, payload),
    onSuccess: (data) => {
      queryClient.invalidateQueries({
        queryKey: SAVED_FILTERS_QUERY_KEYS.list(data.filter_context),
      });
      dispatch(sendSuccessToast('Successfully updated saved filter.'));
    },
    onError: () =>
      dispatch(
        sendErrorToast('Failed to update saved filter. Please try again.'),
      ),
  });
};
